module.exports = __webpack_public_path__ + "static/membership-current-promo-82d79b26201a90ec2d09f1d40bc9249b.jpg";